<template>
   <div>
      <el-radio-group style="display: flex; margin-top: 10px" v-model="curSelectVal" :disabled="!disabled"
         @change="changeType">
         <el-radio :label="0">全部</el-radio>
         <el-radio :label="1">部分学生</el-radio>
         <el-radio :label="2">特权角色</el-radio>
      </el-radio-group>
      <div class="margin-top-10" v-if="curSelectVal === 1">
         <el-autocomplete v-model="state" :fetch-suggestions="querySearchAsync" placeholder="请输入学生id"
            @select="handleSelect" :disabled="!disabled"></el-autocomplete>
         <el-button type="primary" :disabled="!disabled" @click="handlePush">添加</el-button>
         <div class="user-box">
            <div class="user-content">
               <el-tag @close="tagClose(item)" v-for="item in selectItemList" type="primary" :key="item.uid"
                  :closable="disabled">
                  <span>{{ item.value }}</span>
                  <span>{{ item.name }}</span>
               </el-tag>
            </div>
            <div class="count">共{{ selectItemList.length }}位</div>
         </div>
      </div>
      <div class="margin-top-10" v-if="curSelectVal === 2">
         <el-select placeholder="请选择特权角色" multiple v-model="selectPrivileges" :disabled="!disabled">
            <el-option v-for="(item, index) in privilegeOptions" :key="index" :label="item.label" :value="item.value">
            </el-option>
         </el-select>
      </div>
   </div>
</template>

<script>
export default {
   props: {
      selectVal: {
         type: Number,
         default: 0,
      },
      privileges: {
         type: String,
         default: ''
      },
      disabled: {
         type: Boolean,
         default: true,
      },
   },
   computed: {
      curSelectVal: {
         get() {
            return this.$props.selectVal;
         },
         set(v) {
            this.$emit("update:selectVal", v);
         },
      },
   },
   data() {
      return {
         timer: null,
         state: "",
         selectItem: "",
         selectItemList: [],
         privilegeOptions: [],
         selectPrivileges: [],
      };
   },

   watch: {
      privileges: {
         handler(newValue, oldVal) {
            if (newValue && newValue !== '') {
               this.selectPrivileges = this.privileges.split(',');
            }
         },
         immediate: true,
      }
   },

   mounted() {
      this.queryPrivilegeRoles();
   },

   methods: {
      handlePush() {
         if (
            this.selectItem &&
            !this.selectItemList.find(
               (item) => item.value === this.selectItem.value
            )
         ) {
            this.selectItemList.push(this.selectItem);
         }
      },
      querySearchAsync(queryString, cb) {
         if (!queryString) {
            this.selectItem = "";
            return cb([]);
         }
         if (isNaN(Number(queryString))) {
            this.selectItem = "";
            return cb([]);
         }
         clearTimeout(this.timer);
         this.timer = setTimeout(async () => {
            const res = await this.$http({
               url: this.$util.domain + "/adminapi/v2/user/basicUser/list",
               method: "post",
               body: JSON.stringify({
                  keyType: 0,
                  keyword: queryString,
               }),
            });
            if (res.data.error === 10000) {
               //cb返回指定格式的结果
               const result = res.data.data.dataList.map((item) => ({
                  uid: item.uid,
                  value: item.name,
               }));
               if (!result.length) {
                  this.selectItem = "";
               }
               cb(result);
            } else {
               cb([]);
               this.selectItem = "";
            }
         }, 500);
      },
      // 查询全部特权角色
      queryPrivilegeRoles() {
         this.$http({
            url: this.$util.domain + "/adminapi/privilege/v1/queryAll",
            method: "GET",
         }).then((res) => {
            const content = res.body.data || [];
            this.privilegeOptions = content.map((item) => ({
               label: item.name,
               value: `${item.id}`
            }));
            if (this.privileges && this.privileges !== '') {
               this.selectPrivileges = this.privileges.split(',');
            }
         }).catch((err) => {
            this.privilegeOptions = [];
         })
      },
      // 切换类型
      changeType(value) {
         this.selectItemList = [];
         this.selectPrivileges = [];
      },
      handleSelect(item) {
         this.selectItem = item;
      },
      tagClose(row) {
         this.selectItemList = this.selectItemList.filter(
            (item) => item.value !== row.value
         );
      },
   },
};
</script>

<style scoped>
.user-box {
   width: 350px;
}

.user-box .count {
   text-align: right;
}

.user-content {
   width: 100%;
   height: 300px;
   border: 1px solid #8e8e8e;
   margin-top: 5px;
   border-radius: 4px;
   overflow-y: scroll;
}

.el-tag {
   margin: 5px;
   float: left;
}

.el-select {
   width: 560px;
}
</style>


// WEBPACK FOOTER //
// SelectStudent.vue?615453d0